var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "catalog-entry-cell"
  }, [_vm.showCatalogEntries && _vm.catalogEntries.length ? _c('div', {
    staticClass: "catalog-entry-cell__entries"
  }, _vm._l(_vm.catalogEntries, function (entry) {
    return _c('v-chip', {
      key: entry.id,
      staticClass: "catalog-entry-cell__chip",
      attrs: {
        "x-small": "",
        "label": "",
        "outlined": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "x-small": "",
        "left": ""
      }
    }, [_vm._v(" " + _vm._s(entry.is_default ? "mdi-star-outline" : "mdi-tag-outline") + " ")]), _vm._v(" " + _vm._s(_vm.formatEntryLabel(entry)) + " ")], 1);
  }), 1) : _vm.showCatalogEntries && !_vm.showFormatPicker ? _c('span', {
    staticClass: "text-caption grey--text text--darken-1"
  }, [_vm._v(" " + _vm._s(_vm.$translate("notInCatalog")) + " ")]) : _vm._e(), _vm.showFormatPicker ? _c('FormatSelect', {
    attrs: {
      "value": _vm.formatId,
      "formats": _vm.compatibleFormatOptions,
      "label": _vm.$translate('format'),
      "unit-option-label": _vm.unitOptionLabel,
      "loading": _vm.formatsLoading,
      "error-messages": _vm.formatErrors,
      "variant": "sale",
      "input-class": "catalog-entry-cell__format mt-1"
    },
    on: {
      "input": _vm.onFormatChange
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }